import { reactive } from 'vue';
import { toast } from './useDialogs';

export const ui = reactive({
  project: { open: false, roadmapId: null, projectId: null }
});

export function openProject(roadmapId, projectId = null) {
  Object.assign(ui.project, { open: true, roadmapId, projectId });
}

export function openSettings() {
  toast('Team and phase settings are in the full app');
}
